import { render, staticRenderFns } from "./PageHomeShop.vue?vue&type=template&id=3b61e2de&scoped=true&"
import script from "./PageHomeShop.vue?vue&type=script&lang=js&"
export * from "./PageHomeShop.vue?vue&type=script&lang=js&"
import style0 from "./PageHomeShop.vue?vue&type=style&index=0&id=3b61e2de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b61e2de",
  null
  
)

export default component.exports